import React, { useEffect, useState } from 'react';
import { Save, Loader2, Palette, Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../../api/client';
import UploadField from './UploadField';

const inp = 'w-full bg-navy-dark border border-white/20 rounded-lg px-3 py-2 text-white text-sm focus:outline-none focus:border-pink-brand';
const lbl = 'text-white/60 text-[10px] font-bold uppercase tracking-widest mb-1 block';
const Card = ({ children }) => <div className="glass-card p-5">{children}</div>;
const Loader = () => <div className="text-center py-8"><Loader2 className="text-pink-brand animate-spin mx-auto" /></div>;

export default function ConcorsoEditor() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.getConcorso().then((d) => setData({
      visibile: d.visibile !== false,
      etichetta: d.etichetta || 'Novità 2026',
      titolo: d.titolo || '',
      descrizione: d.descrizione || '',
      dettagli: d.dettagli || '',
      premiazione: d.premiazione || '',
      icon_url: d.icon_url || '',
    })).catch(() => setData({ visibile: true, etichetta: 'Novità 2026', titolo: '', descrizione: '', dettagli: '', premiazione: '', icon_url: '' }));
  }, []);

  if (!data) return <Loader />;
  const set = (k, v) => setData((p) => ({ ...p, [k]: v }));

  const save = async () => {
    setSaving(true);
    try { await api.saveConcorso(data); toast.success('Concorso salvato'); }
    catch (e) { toast.error(e?.message || 'Errore salvataggio'); }
    setSaving(false);
  };

  return (
    <div className="space-y-4" data-testid="concorso-editor">
      <Card>
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-white font-bold text-lg flex items-center gap-2"><Palette size={18} className="text-pink-brand" /> Concorso di Disegno</h2>
          <button onClick={save} disabled={saving} className="btn-primary !py-2 !px-5"><Save size={14} /> {saving ? 'Salvo…' : 'Salva tutto'}</button>
        </div>
        <p className="text-white/60 text-xs mb-3">Sezione mostrata in homepage. Qui modifichi tutto il contenuto del banner del concorso.</p>

        <button
          onClick={() => set('visibile', !data.visibile)}
          className={`w-full mb-3 px-4 py-2.5 rounded-lg border text-xs font-bold uppercase tracking-widest inline-flex items-center justify-center gap-2 transition-colors ${
            data.visibile ? 'bg-green-500/15 border-green-500/30 text-green-400' : 'bg-red-500/15 border-red-500/30 text-red-400'
          }`}
        >
          {data.visibile ? <><Eye size={14} /> Visibile in homepage — clicca per nascondere</> : <><EyeOff size={14} /> Nascosto — clicca per renderlo visibile</>}
        </button>

        <div className="grid sm:grid-cols-2 gap-3">
          <div><label className={lbl}>Etichetta superiore (badge rosa)</label><input className={inp} value={data.etichetta} onChange={(e) => set('etichetta', e.target.value)} placeholder="Novità 2026" /></div>
          <div><label className={lbl}>Data premiazione</label><input className={inp} value={data.premiazione} onChange={(e) => set('premiazione', e.target.value)} placeholder="Premiazione Domenica 31 Maggio" /></div>
          <div className="sm:col-span-2"><label className={lbl}>Titolo</label><input className={inp} value={data.titolo} onChange={(e) => set('titolo', e.target.value)} placeholder="1ª Edizione Concorso di Disegno" /></div>
          <div className="sm:col-span-2"><label className={lbl}>Descrizione (paragrafo principale)</label><textarea rows={3} className={inp} value={data.descrizione} onChange={(e) => set('descrizione', e.target.value)} /></div>
          <div className="sm:col-span-2"><label className={lbl}>Dettagli (paragrafo secondario)</label><textarea rows={2} className={inp} value={data.dettagli} onChange={(e) => set('dettagli', e.target.value)} /></div>
        </div>

        <div className="mt-3">
          <UploadField label="Icona/illustrazione (opzionale, sostituisce il trofeo di default)" accept="image/*" folder="concorso" value={data.icon_url} onChange={(v) => set('icon_url', v)} />
        </div>
      </Card>

      <button onClick={save} disabled={saving} className="btn-primary"><Save size={14} /> {saving ? 'Salvo…' : 'Salva tutto'}</button>
    </div>
  );
}
